/* ============================================================
   LEVELUP ONE — ข้อมูลโซลูชันนวัตกรรม (ใช้ร่วมหน้า Innovation
   และหน้า Innovation Detail)
   ============================================================ */

/* ---- ตัวช่วยสร้างแพ็กเกจ ----
   unit: "/เดือน" (subscription) หรือ "/โปรเจกต์" (งานพัฒนา)
   custom: แพ็กเกจปรับแต่งเฉพาะ ราคา "ติดต่อเรา" */
const plan = (name, price, note, points, opts = {}) => ({
  name, price, note, points,
  unit: opts.unit || "/เดือน",
  featured: !!opts.featured,
  custom: !!opts.custom,
  cta: opts.cta || (opts.custom ? "ขอใบเสนอราคา" : "เริ่มต้นใช้งาน"),
});

/* แพ็กเกจ Custom ใช้ร่วมกันทุกระบบ */
const CUSTOM_PLAN = plan("Custom", "ติดต่อเรา", "สำหรับองค์กร/ความต้องการเฉพาะ", [
  "ไม่จำกัดสาขาและผู้ใช้งาน",
  "ปรับแต่งฟีเจอร์เฉพาะธุรกิจ",
  "เชื่อมต่อระบบภายนอกผ่าน API",
  "ทีมดูแลเฉพาะทาง + SLA",
  "อบรมทีมแบบ on-site",
], { custom: true });

/* แพ็กเกจรายระบบ (key = slug) */
export const PLANS = {
  laundry: [
    plan("Starter", "1,490", "ร้านเดียว เริ่มต้นใช้งาน", ["1 สาขา", "ติดตามสถานะงานเรียลไทม์", "แจ้งเตือนลูกค้าผ่าน LINE", "รายงานพื้นฐาน"]),
    plan("Business", "3,900", "หลายสาขา ฟีเจอร์ครบ", ["สูงสุด 5 สาขา", "จัดการลูกค้าและสมาชิก", "ชำระเงินออนไลน์", "รายงานเชิงลึก", "Priority support"], { featured: true }),
    CUSTOM_PLAN,
  ],
  fitness: [
    plan("Starter", "1,990", "ฟิตเนสเล็ก เริ่มต้น", ["1 สาขา", "จัดการสมาชิกและแพ็กเกจ", "จองคลาสออนไลน์", "แจ้งเตือนต่ออายุ"]),
    plan("Business", "4,900", "หลายสาขา ครบทุกฟีเจอร์", ["สูงสุด 5 สาขา", "ตารางเทรนเนอร์", "ระบบสะสมแต้ม", "รายงานสมาชิกเชิงลึก", "Priority support"], { featured: true }),
    CUSTOM_PLAN,
  ],
  warehouse: [
    plan("Starter", "2,490", "คลังเดียว สต็อกพื้นฐาน", ["1 คลัง", "รับเข้า-เบิกออก", "สแกนบาร์โค้ด", "รายงานสต็อก"]),
    plan("Business", "6,900", "หลายคลัง โอนย้ายได้", ["สูงสุด 5 คลัง", "โอนย้ายระหว่างคลัง", "จุดสั่งซื้ออัตโนมัติ", "รายงานเชิงลึก", "Priority support"], { featured: true }),
    CUSTOM_PLAN,
  ],
  "retail-pos": [
    plan("Starter", "1,290", "ร้านเดียว ขายหน้าร้าน", ["1 สาขา", "ขายหน้าร้าน + ออนไลน์", "ซิงก์สต็อกอัตโนมัติ", "สรุปยอดรายวัน"]),
    plan("Business", "3,490", "หลายสาขา รวมทุกช่องทาง", ["สูงสุด 5 สาขา", "รายงานรวมทุกสาขา", "ระบบสมาชิก/แต้ม", "ชำระเงินหลายรูปแบบ", "Priority support"], { featured: true }),
    CUSTOM_PLAN,
  ],
  "restaurant-booking": [
    plan("Starter", "990", "ร้านเล็ก เริ่มต้นรับจอง", ["จองโต๊ะออนไลน์", "ระบบคิวพื้นฐาน", "แจ้งเตือนผ่าน LINE"]),
    plan("Business", "2,900", "ร้านใหญ่ จัดการเต็มรูปแบบ", ["จองหลายช่วงเวลา", "จัดการผังโต๊ะ", "รายงานการจอง", "Priority support"], { featured: true }),
    CUSTOM_PLAN,
  ],
  erp: [
    plan("Starter", "4,900", "ธุรกิจขนาดเล็ก", ["3 ผู้ใช้", "บัญชี + สต็อก + ขาย", "ใบกำกับ e-Tax", "รายงานพื้นฐาน"]),
    plan("Business", "12,900", "ธุรกิจที่กำลังโต", ["15 ผู้ใช้", "เชื่อมทุกแผนก", "เวิร์กโฟลว์อนุมัติ", "รายงานเชิงลึก", "Priority support"], { featured: true }),
    CUSTOM_PLAN,
  ],
  "pos-cloud": [
    plan("Starter", "990", "ร้านเดียว เริ่มต้น", ["1 จุดขาย", "ทำงานออฟไลน์", "ออกบิลรวดเร็ว", "สรุปยอดรายวัน"]),
    plan("Business", "2,490", "หลายจุดขาย", ["สูงสุด 5 จุดขาย", "ซิงก์อัตโนมัติทุกเครื่อง", "จัดการสินค้า/โปรโมชัน", "Priority support"], { featured: true }),
    CUSTOM_PLAN,
  ],
  "web-app": [
    plan("Starter", "39,000", "เว็บแอปขนาดเล็ก", ["ออกแบบ UX/UI", "สูงสุด 5 หน้าจอหลัก", "รองรับมือถือ", "ดูแล 1 เดือน"], { unit: "/โปรเจกต์" }),
    plan("Business", "89,000", "เว็บแอปครบฟีเจอร์", ["ฟีเจอร์ตามโจทย์", "ระบบหลังบ้าน + API", "เชื่อมระบบภายนอก", "ดูแล 3 เดือน"], { unit: "/โปรเจกต์", featured: true }),
    CUSTOM_PLAN,
  ],
  "mobile-app": [
    plan("Starter", "59,000", "แอปเริ่มต้น", ["iOS หรือ Android", "ฟีเจอร์หลัก", "เชื่อมระบบหลังบ้าน", "ดูแล 1 เดือน"], { unit: "/โปรเจกต์" }),
    plan("Business", "149,000", "แอประดับโปรดักชัน", ["iOS + Android", "Push Notification", "ล็อกอินปลอดภัย", "ดูแล 3 เดือน"], { unit: "/โปรเจกต์", featured: true }),
    CUSTOM_PLAN,
  ],
  "ai-analytics": [
    plan("Starter", "2,900", "เริ่มต้นวิเคราะห์ข้อมูล", ["เชื่อม 1 แหล่งข้อมูล", "แดชบอร์ดสำเร็จรูป", "ถามตอบด้วยภาษาคน"]),
    plan("Business", "7,900", "วิเคราะห์เชิงลึก", ["หลายแหล่งข้อมูล", "พยากรณ์แนวโน้ม", "ข้อเสนอแนะอัตโนมัติ", "Priority support"], { featured: true }),
    CUSTOM_PLAN,
  ],
  inventory: [
    plan("Starter", "1,990", "สต็อกพื้นฐาน", ["1 คลัง", "ติดตามทุก SKU", "จุดสั่งซื้ออัตโนมัติ"]),
    plan("Business", "4,900", "หลายคลัง ครบวงจร", ["หลายคลัง", "โอนย้ายระหว่างคลัง", "รายงานเชิงลึก", "Priority support"], { featured: true }),
    CUSTOM_PLAN,
  ],
  crm: [
    plan("Starter", "1,490", "ทีมเล็ก เริ่มต้น", ["3 ผู้ใช้", "ฐานข้อมูลลูกค้า", "ติดตามดีล"]),
    plan("Business", "3,900", "ทีมขายเต็มรูปแบบ", ["15 ผู้ใช้", "การตลาดอัตโนมัติ", "รายงานการขาย", "Priority support"], { featured: true }),
    CUSTOM_PLAN,
  ],
};

/* fallback หากยังไม่ได้กำหนดแพ็กเกจเฉพาะ */
export const DEFAULT_PLANS = [
  plan("Starter", "1,990", "สำหรับเริ่มต้น", ["1 ผู้ใช้/สาขา", "ฟีเจอร์หลัก", "Email support"]),
  plan("Business", "4,900", "สำหรับธุรกิจที่กำลังโต", ["สูงสุด 5 ผู้ใช้/สาขา", "ฟีเจอร์ครบ", "Priority support"], { featured: true }),
  CUSTOM_PLAN,
];

/* คืนแพ็กเกจของระบบตาม slug */
export const getPlans = (slug) => PLANS[slug] || DEFAULT_PLANS;

export const SOLUTIONS = [
  {
    slug: "laundry", badge: "Laundry", featured: true,
    title: "ระบบซักรีด ที่โตได้ไม่หยุด",
    short: "ระบบจัดการร้านซักรีด",
    tagline: "ติดตาม Real-time · หลายสาขา · ชำระเงินออนไลน์",
    desc: "จัดการทุกสาขาจากมือถือ — รู้สถานะงานทุกชิ้น ลูกค้าติดตามเองได้ ลด No-show 40%",
    photo: "https://images.unsplash.com/photo-1545173168-9f1947eebb7f?auto=format&fit=crop&w=1000&q=80",
    features: [
      { ico: "⚡", title: "ระบบติดตามสถานะแบบ Real-time", desc: "ติดตามสถานะการซักรีดได้ตลอดเวลา ตั้งแต่รับเข้าจนถึงส่งมอบ" },
      { ico: "👥", title: "การจัดการลูกค้าและคำสั่งซื้อ", desc: "ระบบจัดการข้อมูลลูกค้าและคำสั่งซื้อครบวงจร" },
      { ico: "📊", title: "ระบบบัญชีและรายงาน", desc: "รายงานการเงินและการดำเนินงานที่ครบถ้วน" },
      { ico: "🏢", title: "รองรับหลายสาขา", desc: "บริหารจัดการหลายสาขาได้จากที่เดียว" },
    ],
  },
  {
    slug: "fitness", badge: "Fitness", featured: true,
    title: "ระบบฟิตเนส ที่สมาชิกรัก",
    short: "ระบบฟิตเนส",
    tagline: "สมาชิก · แพ็กเกจ · จองคลาสออนไลน์",
    desc: "จัดการสมาชิก แพ็กเกจ และตารางคลาส ลดงานแอดมิน 60% ต่ออายุอัตโนมัติผ่าน LINE",
    photo: "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?auto=format&fit=crop&w=1000&q=80",
    features: [
      { ico: "🎫", title: "จัดการสมาชิก & แพ็กเกจ", desc: "ระบบสมาชิก ต่ออายุ และแพ็กเกจหลากหลายรูปแบบ" },
      { ico: "📅", title: "จองคลาสออนไลน์", desc: "สมาชิกจองคลาสและคิวเทรนเนอร์ได้เอง 24 ชม." },
      { ico: "🔔", title: "แจ้งเตือนอัตโนมัติ", desc: "เตือนต่ออายุและตารางคลาสผ่าน LINE" },
      { ico: "📊", title: "รายงานสมาชิก", desc: "วิเคราะห์การเข้าใช้และยอดต่ออายุ" },
    ],
  },
  {
    slug: "warehouse", badge: "Warehouse", featured: true,
    title: "คลังสินค้า ที่ไม่มีของขาดหาย",
    short: "คลังสินค้าอัจฉริยะ",
    tagline: "รับเข้า-เบิกออก · ตรวจนับ · รายงานเรียลไทม์",
    desc: "ติดตามสต็อกทุก SKU แบบเรียลไทม์ ลดสต็อกคลาดเคลื่อน 35% รู้ของใกล้หมดทันที",
    photo: "https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1000&q=80",
    features: [
      { ico: "📦", title: "รับเข้า-เบิกออก-โอน", desc: "จัดการความเคลื่อนไหวสต็อกครบทุกขั้นตอน" },
      { ico: "🔎", title: "ตรวจนับด้วยบาร์โค้ด", desc: "นับสต็อกรวดเร็วและแม่นยำด้วยการสแกน" },
      { ico: "🔔", title: "เตือนของใกล้หมด", desc: "แจ้งเตือนเมื่อสินค้าถึงจุดสั่งซื้อ" },
      { ico: "📊", title: "รายงานสต็อกเรียลไทม์", desc: "เห็นภาพรวมคลังได้ทันทีทุกเวลา" },
    ],
  },
  {
    slug: "retail-pos", badge: "Retail POS", featured: true,
    title: "POS ค้าปลีกได้ทุกช่องทาง",
    short: "POS ร้านค้าปลีกหลายสาขา",
    tagline: "ขายหน้าร้าน/ออนไลน์ · ซิงก์สต็อก · หลายสาขา",
    desc: "ขายได้ทุกช่องทาง ซิงก์สต็อกอัตโนมัติ เพิ่มยอดขาย 25% ดูรายงานรวมทุกสาขา",
    photo: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1000&q=80",
    features: [
      { ico: "🛒", title: "ขายหน้าร้าน & ออนไลน์", desc: "รวมการขายทุกช่องทางในระบบเดียว" },
      { ico: "🔄", title: "ซิงก์สต็อกอัตโนมัติ", desc: "สต็อกตรงกันทุกช่องทางแบบเรียลไทม์" },
      { ico: "🏢", title: "รองรับหลายสาขา", desc: "ดูรายงานรวมและแยกสาขาได้" },
      { ico: "💳", title: "ชำระเงินหลายรูปแบบ", desc: "รองรับเงินสด โอน บัตร และ e-Wallet" },
    ],
  },
  {
    slug: "restaurant-booking", badge: "Restaurant", featured: false,
    title: "ระบบจองคิวร้านอาหาร",
    short: "ระบบจองคิวร้านอาหาร",
    tagline: "จองโต๊ะ · จัดคิว · แจ้งเตือน",
    desc: "ลูกค้าจองโต๊ะและรับคิวออนไลน์ ลดเวลารอและการจองซ้ำซ้อน",
    photo: "https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&w=1000&q=80",
    features: [
      { ico: "📅", title: "จองโต๊ะออนไลน์", desc: "ลูกค้าจองล่วงหน้าได้ตลอดเวลา" },
      { ico: "🔢", title: "ระบบคิวอัจฉริยะ", desc: "จัดคิวอัตโนมัติและแจ้งเตือนเมื่อถึงคิว" },
      { ico: "🔔", title: "แจ้งเตือนผ่าน LINE", desc: "ลดการพลาดนัดด้วยการแจ้งเตือน" },
      { ico: "📊", title: "รายงานการจอง", desc: "วิเคราะห์ช่วงเวลาขายดีและพฤติกรรมลูกค้า" },
    ],
  },
  {
    slug: "erp", badge: "ERP", featured: false,
    title: "ERP ทั้งบริษัทใน 1 ที่เดียว",
    short: "ERP ทั้งบริษัทใน 1 ที่เดียว",
    tagline: "บัญชี · สต็อก · ขาย เชื่อมทุกแผนก",
    desc: "เชื่อมทุกแผนกในระบบเดียว ติดตั้งได้ใน 1 สัปดาห์ ดูภาพรวมธุรกิจแบบเรียลไทม์",
    photo: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1000&q=80",
    features: [
      { ico: "🔗", title: "เชื่อมทุกแผนก", desc: "บัญชี สต็อก ขาย และ HR ในระบบเดียว" },
      { ico: "⚡", title: "ติดตั้งไว", desc: "เริ่มใช้งานได้ภายใน 1 สัปดาห์" },
      { ico: "📊", title: "ภาพรวมเรียลไทม์", desc: "ดูสถานะธุรกิจทุกมุมได้ทันที" },
      { ico: "🧾", title: "ใบกำกับ e-Tax", desc: "ออกใบกำกับภาษีอิเล็กทรอนิกส์ได้" },
    ],
  },
  {
    slug: "pos-cloud", badge: "Cloud POS", featured: false,
    title: "POS Cloud ที่ไม่มีสะดุด",
    short: "POS Cloud ที่ไม่มีสะดุด",
    tagline: "ทำงานออฟไลน์ได้ · ซิงก์อัตโนมัติ",
    desc: "ขายต่อได้แม้เน็ตหลุด แล้วซิงก์ข้อมูลอัตโนมัติเมื่อกลับมาออนไลน์",
    photo: "https://images.unsplash.com/photo-1556740738-b6a63e27c4df?auto=format&fit=crop&w=1000&q=80",
    features: [
      { ico: "📴", title: "ทำงานออฟไลน์", desc: "ขายต่อได้แม้อินเทอร์เน็ตขัดข้อง" },
      { ico: "🔄", title: "ซิงก์อัตโนมัติ", desc: "ข้อมูลอัปเดตทันทีเมื่อออนไลน์" },
      { ico: "🧾", title: "ออกบิลรวดเร็ว", desc: "หน้าจอขายที่ใช้ง่าย รวดเร็ว" },
      { ico: "📊", title: "สรุปยอดรายวัน", desc: "ปิดยอดและดูรายงานได้ทันที" },
    ],
  },
  {
    slug: "web-app", badge: "Web App", featured: false,
    title: "Web Application Platform",
    short: "Web Application Platform",
    tagline: "เว็บแอปเฉพาะธุรกิจ ขยายได้ตามต้องการ",
    desc: "พัฒนาเว็บแอปตามโจทย์จริงของคุณ รองรับการเติบโตในระยะยาว",
    photo: "https://images.unsplash.com/photo-1547658719-da2b51169166?auto=format&fit=crop&w=1000&q=80",
    features: [
      { ico: "🧩", title: "ออกแบบเฉพาะธุรกิจ", desc: "ฟีเจอร์ตรงกับกระบวนการของคุณ" },
      { ico: "📈", title: "รองรับการเติบโต", desc: "สถาปัตยกรรมที่ขยายได้" },
      { ico: "🔐", title: "ปลอดภัย", desc: "มาตรฐานความปลอดภัยระดับองค์กร" },
      { ico: "🔗", title: "เชื่อมระบบอื่น", desc: "ต่อ API กับเครื่องมือที่ใช้อยู่" },
    ],
  },
  {
    slug: "mobile-app", badge: "Mobile App", featured: false,
    title: "LevelUp Mobile App",
    short: "LevelUp Mobile App",
    tagline: "แอป iOS / Android สำหรับธุรกิจคุณ",
    desc: "แอปมือถือคุณภาพระดับโปรดักชัน เชื่อมต่อระบบหลังบ้านได้ครบ",
    photo: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1000&q=80",
    features: [
      { ico: "📱", title: "iOS & Android", desc: "ครอบคลุมผู้ใช้ทุกอุปกรณ์" },
      { ico: "🔔", title: "Push Notification", desc: "แจ้งเตือนผู้ใช้แบบเรียลไทม์" },
      { ico: "🔗", title: "ต่อระบบหลังบ้าน", desc: "เชื่อมข้อมูลกับระบบของคุณ" },
      { ico: "🔐", title: "ล็อกอินปลอดภัย", desc: "รองรับ Face ID / Touch ID" },
    ],
  },
  {
    slug: "ai-analytics", badge: "AI Analytics", featured: false,
    title: "AI Analytics Platform",
    short: "AI Analytics Platform",
    tagline: "เปลี่ยนข้อมูลให้เป็นข้อมูลเชิงลึก",
    desc: "วิเคราะห์ข้อมูลธุรกิจด้วย AI ช่วยตัดสินใจด้วยข้อมูลจริง",
    photo: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&w=1000&q=80",
    features: [
      { ico: "🔎", title: "ค้นหาด้วยภาษาคน", desc: "ถามข้อมูลเป็นภาษาธรรมชาติ" },
      { ico: "📈", title: "วิเคราะห์แนวโน้ม", desc: "พยากรณ์และเห็นแพตเทิร์น" },
      { ico: "📊", title: "แดชบอร์ดสด", desc: "ภาพรวมตัวเลขสำคัญแบบเรียลไทม์" },
      { ico: "🧠", title: "ข้อเสนอแนะอัตโนมัติ", desc: "AI ช่วยชี้จุดที่ควรปรับปรุง" },
    ],
  },
  {
    slug: "inventory", badge: "Inventory", featured: false,
    title: "Inventory Management",
    short: "Inventory Management",
    tagline: "จัดการสต็อกอัจฉริยะ",
    desc: "คุมสต็อกให้พอดี ลดของค้างและของขาด ด้วยระบบที่แม่นยำ",
    photo: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1000&q=80",
    features: [
      { ico: "📦", title: "ติดตามทุก SKU", desc: "รู้จำนวนคงเหลือแบบเรียลไทม์" },
      { ico: "🔔", title: "จุดสั่งซื้ออัตโนมัติ", desc: "เตือนเมื่อถึงเวลาเติมของ" },
      { ico: "🔄", title: "โอนย้ายระหว่างคลัง", desc: "บริหารหลายคลังได้สะดวก" },
      { ico: "📊", title: "รายงานเชิงลึก", desc: "วิเคราะห์ของขายดี/ขายช้า" },
    ],
  },
  {
    slug: "crm", badge: "CRM", featured: false,
    title: "CRM System",
    short: "CRM System",
    tagline: "ดูแลความสัมพันธ์ลูกค้าครบวงจร",
    desc: "เก็บข้อมูลลูกค้า ติดตามดีล และทำการตลาดอัตโนมัติในที่เดียว",
    photo: "https://images.unsplash.com/photo-1552581234-26160f608093?auto=format&fit=crop&w=1000&q=80",
    features: [
      { ico: "👤", title: "ฐานข้อมูลลูกค้า", desc: "รวมข้อมูลและประวัติการติดต่อ" },
      { ico: "📈", title: "ติดตามดีล", desc: "ดูสถานะการขายเป็นขั้นตอน" },
      { ico: "📣", title: "การตลาดอัตโนมัติ", desc: "ส่งแคมเปญตามกลุ่มลูกค้า" },
      { ico: "📊", title: "รายงานการขาย", desc: "วัดผลทีมขายได้ชัดเจน" },
    ],
  },
];

export const findSolution = (slug) => SOLUTIONS.find((s) => s.slug === slug) || null;
